import { render, staticRenderFns } from "./PurposeOpenAccount.vue?vue&type=template&id=69dc29a8&scoped=true&"
import script from "./PurposeOpenAccount.vue?vue&type=script&lang=js&"
export * from "./PurposeOpenAccount.vue?vue&type=script&lang=js&"
import style0 from "./PurposeOpenAccount.vue?vue&type=style&index=0&id=69dc29a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc29a8",
  null
  
)

export default component.exports